import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const logisticcoordinatorsAdapter = getAdapter();
const logisticcoordinatorsSlice = createSlice({
  name: 'logisticcoordinators',
  initialState: logisticcoordinatorsAdapter.getInitialState(),
  reducers: {
    setLogisticCoordinators: (state, { payload: { logisticcoordinators } }) => {
      logisticcoordinatorsAdapter.setAll(state, logisticcoordinators);
    }
  }
});

const selectors = logisticcoordinatorsAdapter.getSelectors(({ logisticcoordinators }) => logisticcoordinators);

export const getLogisticCoordinatorsIncludingDeleted = state => selectors.selectAll(state);

export const getLogisticCoordinators = state => getLogisticCoordinatorsIncludingDeleted(state).filter(({ active }) => active);

export const { setLogisticCoordinators } = logisticcoordinatorsSlice.actions;

export default logisticcoordinatorsSlice.reducer;
